import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import * as queryString from "query-string";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import { currencyFormatter } from "utils/currencyHelper";
import { HamburgerIcon, RightArrowIcon } from "component/icons";
import { UserProfileIcon } from "component/icons";
import { LanguageMenu } from "component/menu";
import { ReactComponent as UnitedKingdomFlag } from "assets/flags/united-kingdom.svg";
import { ReactComponent as ChinaFlag } from "assets/flags/china.svg";
import { ReactComponent as JapanFlag } from "assets/flags/japan.svg";
import { ReactComponent as SpainFlag } from "assets/flags/spain.svg";
import { ReactComponent as FranceFlag } from "assets/flags/france.svg";
import { ReactComponent as RussiaFlag } from "assets/flags/russia.svg";
import { ReactComponent as BrazilFlag } from "assets/flags/brazil.svg";
import { ReactComponent as ThailandFlag } from "assets/flags/thailand.svg";
import { ReactComponent as KoreaFlag } from "assets/flags/korea.svg";
import { ReactComponent as TaiwanFlag } from "assets/flags/taiwan.svg";
import { ReactComponent as ChooseLanguageIcon } from "assets/icons/chooseLanguageIc.svg";
import { ReactComponent as SignOutIcon } from "assets/icons/exitIcon.svg";
import { ReactComponent as HistoryIcon } from "assets/icons/viewHistoryIc.svg";
import { ReactComponent as CashierIcon } from "assets/icons/cashInOut.svg";
import { ReactComponent as SwitchDevice } from "assets/icons/switchDevice.svg";
import { ReactComponent as ScreensIcon } from "assets/icons/multiGamePlayIcon.svg";
import { ReactComponent as ContinuePlayingIcon } from "assets/icons/continuePlayingIc.svg";
import { ReactComponent as ProviderSettingIcon } from "assets/icons/provider-logo-settings.svg";

import { isEmpty, isEqual } from "lodash";

import ExitDialogModal from "component/modal/ExitDialog";

import "containers/Menu/styles.scss";

const LANGUAGE_PANEL = "LANGUAGE_PANEL";

class Menu extends Component {
  constructor(props) {
    super(props);
    this.setMenuVisibility = this._setMenuVisibility.bind(this);
    this.setGameHistoryVisibility = this._setGameHistoryVisibility.bind(this);
    this.onPanelClose = this._onPanelClose.bind(this);
    this.onExitClick = this._onExitClick.bind(this);
    this.onBetHistoryClick = this._onBetHistoryClick.bind(this);
    this.state = {
      activePanel: null,
      showExitModal: false,
      language: null,
      isProviderLogoOn: this.props.showProviderLogoOnGames
    };
  }

  componentDidMount() {
    let menu = this.props.getMenu();

    if (menu) {
      this.setState(menu.toJSON());
    } else {
      this.props.setMenu({
        expand: false,
        activePanel: null,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.showProviderLogoOnGames !== this.props.showProviderLogoOnGames) {
      this.setState({ 
        isProviderLogoOn: this.props.showProviderLogoOnGames 
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      !this.props.recentlyPlayedGames &&
      !isEqual(this.props.recentlyPlayedGames, nextProps.recentlyPlayedGames)
    ) {
      this.props.wlFetchProfile();
    }

    if (
      !isEqual(
        this.props.supportedLanguagesLink,
        nextProps.supportedLanguagesLink
      ) &&
      !this.props.showMenu
    ) {
      this.props
        .fetchLanguage(nextProps.supportedLanguagesLink)
        .then((response) => {
          return this.props.setLanguage(response);
        })
        .then((response) => {
          this.setState({
            language: response,
          });
        })
        .catch((err) => {
          throw err;
        });
    }
  }

  _setGameHistoryVisibility = () => {
    this.props.setGameHistoryVisibility(!this.props.showGameHistory);
  };

  _onPanelClose() {
    this.setState({
      activePanel: null,
    });
    this.props.setMenu({
      activePanel: null,
    });
  }

  getFlag() {
    let { locale } = this.props.match.params;

    let ActiveFlag;

    switch (locale) {
      case "zh-CN":
      case "zh_CN":
        ActiveFlag = ChinaFlag;
        break;
      case "zh-TW":
      case "zh_TW":
        ActiveFlag = TaiwanFlag;
        break;
      case "ja-JP":
      case "ja_JP":
        ActiveFlag = JapanFlag;
        break;
      case "es-ES":
      case "es_ES":
        ActiveFlag = SpainFlag;
        break;
      case "fr-FR":
      case "fr_FR":
        ActiveFlag = FranceFlag;
        break;
      case "ru-RU":
      case "ru_RU":
        ActiveFlag = RussiaFlag;
        break;
      case "pt-BR":
      case "pt_BR":
        ActiveFlag = BrazilFlag;
        break;
      case "th-TH":
      case "th_TH":
        ActiveFlag = ThailandFlag;
        break;
      case "ko-KR":
      case "ko_KR":
        ActiveFlag = KoreaFlag;
        break;
      default:
        ActiveFlag = UnitedKingdomFlag;
        break;
    }

    return <ActiveFlag />;
  }

  _setMenuVisibility() {
    let newShowMenu = !this.props.showMenu;
    this.props.setMenuVisibility(newShowMenu);
    this.props.setMenu({
      expand: newShowMenu,
      activePanel: this.state.activePanel,
    });

    if (!newShowMenu) {
      this.setState({
        activePanel: null,
      });
    }

    if (!this.props.isMobile) return;

    if (newShowMenu) {
      this.props.showModal("MENU");
    } else {
      this.props.hideModal("MENU");
    }
  }

  _onExitClick() {
    this.setState({
      showExitModal: !this.state.showExitModal,
    });
  }

  _onBetHistoryClick() {
    let params = {
      modalRel: this.props.gameRoundHistoryLink.get("rel"),
      link: JSON.stringify(this.props.gameRoundHistoryLink.toJSON()),
    };
    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params
    )}`;
    this.props.navigateTo(newLoc);
  }

  handleProviderLogoToggle = (newValue) => {
    this.setState({ 
      isProviderLogoOn: newValue 
    });
    
    this.props.setGameProviderImagesEnabled(newValue)
      .then(() => {
        window.location.reload();
      })
      .catch((err) => {
        this.setState({ 
          isProviderLogoOn: !newValue 
        });
      });
  }

  render() {
    const { t, showMenu, filtersVisible } = this.props;

    let params = {
      location: this.props.location,
      url: this.state.gameUrl,
      hideSplash: this.props.hideSplash,
      isMobile: this.props.isMobile,
      appId: this.props.appId,
      target: "_self",
    };
    return (
      <Fragment>
        <div
          className={`menu-container ${showMenu ? "show" : ""}`}
          onClick={this.setMenuVisibility}
        />
        <div
          className={`menu ${this.props.isMobile ? "mobile" : "desktop"} ${
            showMenu ? "active" : "inactive"
          } ${filtersVisible ? "menu-filtervisible" : ""}`}
        >
          {this.props.visibleMenu &&
            (showMenu ? (
              <HamburgerIcon
                onClick={this.setMenuVisibility}
                active={showMenu}
                className={"icon-wrapper"}
              />
            ) : (
              <span />
            ))}
          {showMenu && (
            <div
              className={`content d-flex h-100 flex-column ${
                this.state.activePanel ? "disable" : ""
              }`}
              style={{
                height: `${this.props.height}px`,
              }}
            >
              <div
                className={`row profile group ${
                  !this.props.allowProfileEdit ? "disabled" : ""
                }`}
                onClick={() => {
                  window.parent.postMessage(
                    {
                      type: "PROFILE_UPDATE_REQUESTED",
                    },
                    "*"
                  );
                }}
              >
                <div className="col col-auto">
                  <span className="usericon">
                    <UserProfileIcon />
                  </span>
                </div>
                <div className="col d-flex align-items-center">
                  <div>
                    <div className="name">{this.props.displayName}</div>
                    {this.props.balance && (
                      <div className="balance">
                        <span className="label">{`${t("balance")}: `}</span>
                        <span>
                          {currencyFormatter(this.props.balance, {
                            currency: this.props.currency,
                            symbol: this.props.symbol,
                          })}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                {this.props.allowProfileEdit && (
                  <div className="col col-auto d-flex align-items-center">
                    <RightArrowIcon />
                  </div>
                )}
              </div>

              {(this.props.showCashier ||
                this.props.continuePlayingLink ||
                this.props.gameRoundHistoryLink) && (
                <>
                  <div className="spacer" />
                  <div className="row group">
                    <div className="group-label">{t("whatDoYouWantToDo")}</div>
                    {this.props.showCashier && (
                      <div className="col-12">
                        <button
                          className="item btn"
                          type="button"
                          aria-haspopup="true"
                          aria-expanded="false"
                          onClick={this.props.broadcastCashier}
                        >
                          <span className="icon">
                            <CashierIcon />
                          </span>
                          <label>{t("cashIn")}</label>
                        </button>
                      </div>
                    )}
                    {this.props.continuePlayingLink && (
                      <div className="col-12">
                        <button
                          className="item btn"
                          type="button"
                          aria-haspopup="true"
                          aria-expanded="false"
                          onClick={() => {
                            let params = {
                              showMore: this.props.continuePlayingLink.get(
                                "rel"
                              ),
                              route: btoa(
                                encodeURIComponent(
                                  JSON.stringify(
                                    this.props.continuePlayingLink.toJSON()
                                  )
                                )
                              ),
                            };
                            let newLoc = `${
                              this.props.location.pathname
                            }?${queryString.stringify(params)}`;
                            this.props.navigateTo(newLoc);
                          }}
                        >
                          <span className="icon">
                            <ContinuePlayingIcon />
                          </span>
                          <label>
                            {this.props.continuePlayingLink.get("name")}
                          </label>
                        </button>
                      </div>
                    )}
                    {this.props.gameRoundHistoryLink && (
                      <div className="col-12">
                        <button
                          className="item btn"
                          type="button"
                          aria-haspopup="true"
                          aria-expanded="false"
                          onClick={this.onBetHistoryClick}
                        >
                          <span className="icon">
                            <HistoryIcon />
                          </span>
                          <label>
                            {this.props.gameRoundHistoryLink.get("name")}
                          </label>
                        </button>
                      </div>
                    )}
                  </div>
                </>
              )}

              {this.props.showSwitchDevice && (
                <>
                  <div className="spacer" />
                  <div className="row group">
                    <div className="col-12">
                      <button
                        className="item btn"
                        type="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                        onClick={() => {
                          this.props.broadcastSwitchDevice(params);
                        }}
                      >
                        <span className="icon icon-switch">
                          <SwitchDevice />
                        </span>
                        <label>{t("switchDevice")}</label>
                      </button>
                    </div>
                  </div>
                </>
              )}

              {(this.props.allowMultiGamePlay || this.props.showLanguage ||
               this.props.canToggleProviderLogoOnGames) && (
                <>
                  <div className="spacer" />
                  <div className="row group">
                    <div className="group-label">{t("settings")}</div>
                    {this.props.showLanguage && (
                      <div className="col-12">
                        <button
                          className="item btn"
                          type="button"
                          aria-haspopup="true"
                          aria-expanded="false"
                          onClick={() => {
                            this.setState({
                              activePanel: LANGUAGE_PANEL,
                            });
                            this.props.setMenu({
                              activePanel: LANGUAGE_PANEL,
                            });
                          }}
                        >
                          <span className="icon">
                            <ChooseLanguageIcon />
                          </span>
                          <label>
                            {this.props.supportedLanguagesLink.get("name")}
                          </label>
                          <span className="flag">{this.getFlag()}</span>
                        </button>
                      </div>
                    )}
                    {this.props.allowMultiGamePlay && (
                      <div className="col-12">
                        <button
                          className="item btn w-100 d-flex"
                          type="button"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <span className="icon">
                            <ScreensIcon />
                          </span>
                          <div className="custom-control custom-control-right custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="customSwitch1"
                              onClick={(event) => {
                                this.props.setMultigameEnabled(
                                  event.currentTarget.checked
                                );
                                this.props.broadcastGameMode(
                                  this.props.isMultiGame ? "SINGLE" : "MULTI"
                                );
                              }}
                              defaultChecked={
                                this.props.isMultiGame ? true : false
                              }
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="customSwitch1"
                            >
                              {t("multiGamePlay")}
                            </label>
                          </div>
                        </button>
                      </div>
                    )}
                    {this.props.canToggleProviderLogoOnGames && (
                      <div className="col-12">
                        <button
                          className="item btn w-100 d-flex"
                          type="button"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <span className="icon providers-icon">
                            <ProviderSettingIcon />
                          </span>
                          <div className="custom-control custom-control-right custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="customSwitch2"
                              checked={this.state.isProviderLogoOn}
                              onChange={(event) => {
                                this.handleProviderLogoToggle(event.currentTarget.checked);
                              }}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="customSwitch2"
                            >
                              {t("providerLogoGames")}
                            </label>
                          </div>
                        </button>
                      </div>
                    )}                 
                  </div>
                </>
              )}

              <div className="flex-fill d-flex justify-content-start">
                <div className="col" />
              </div>
              <div className="spacer" />
              <div className="row footer">
                {this.props.exitLink && (
                  <div className="col-12">
                    <button
                      className="sign-out btn text-center"
                      type="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                      onClick={() => {
                        this.onExitClick();
                      }}
                    >
                      <span className="icon">
                        <SignOutIcon />
                      </span>
                      <label>{this.props.exitLink.get("name")}</label>
                    </button>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col">
                  <div className="version text-center">
                    {`${t("version")}: ${this.props.version}, ${t("build")}: ${
                      this.props.buildno
                    }`}
                  </div>
                </div>
              </div>
            </div>
          )}
          {this.state.showExitModal ? (
            <ExitDialogModal
              onLeaveClickHandler={() => {
                this.props.fetchExit(this.props.exitLink).then((response) => {
                  window.parent.postMessage(
                    {
                      type: "LOBBY_EXITED",
                    },
                    "*"
                  );
                  this.setMenuVisibility();
                  if (!response.url) {
                    window.location.reload();
                  } else {
                    window.location.href = response.url;
                  }
                });
              }}
              onClose={() => {
                this.onExitClick();
              }}
              switchDevice={this.props.showSwitchDevice}
              params={params}
              broadcastSwitchDevice={this.props.broadcastSwitchDevice}
            />
          ) : null}
          {this.props.supportedLanguagesLink &&
            this.state.activePanel === LANGUAGE_PANEL &&
            showMenu && (
              <LanguageMenu
                className="panel"
                show={this.state.activePanel === LANGUAGE_PANEL}
                locale={this.props.match.params.locale}
                isMobile={this.props.isMobile}
                setLocale={this.props.setLocale}
                header={this.props.supportedLanguagesLink.get("name")}
                onClose={() => {
                  this.onPanelClose();
                }}
                supportedLanguagesLink={this.state.language}
              />
            )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let symbols;
  let showCashier;
  let showSwitchDevice;
  let allowMultiGamePlay;
  let canToggleProviderLogoOnGames;
  let showProviderLogoOnGames;

  try {
    showCashier = state.profile.get("showCashier");
  } catch (err) {}
  try {
    showSwitchDevice = state.profile.get("showSwitchDevice");
  } catch (err) {}
  try {
    allowMultiGamePlay = state.links.get("allowMultiGamePlay");
  } catch (err) {}
  try {
    canToggleProviderLogoOnGames = state.profile.getIn(["uiControls", "canToggleProviderLogoOnGames"]);
  } catch (err) {}

  try {
    showProviderLogoOnGames = state.profile.getIn(["preferences", "showProviderLogoOnGames"]);
  } catch (err) {}

  let continuePlayingLink = state.profile.get("links").find((link) => {
    return link.get("rel") === "categories-home.recentlyplayed";
  });
  let supportedLanguagesLink = state.profile.get("links").find((link) => {
    return link.get("rel") === "supportedLanguages";
  });
  let betHistoryLink = state.profile.get("links").find((link) => {
    return link.get("rel") === "service.url";
  });
  let gameRoundHistoryLink = state.profile.get("links").find((link) => {
    return link.get("rel") === "games-round-history.links";
  });
  let exitLink = state.profile.get("links").find((link) => {
    return link.get("rel") === "exit";
  });

  let recentlyPlayedGames = state.games.get("categories-home.recentlyplayed");

  if (!isEmpty(state.user.getIn(["symbol"]))) {
    let symbolList = state.user.getIn(["symbol"]);
    symbolList = symbolList.map((symbol) => {
      return String.fromCharCode(symbol);
    });
    symbols = symbolList.toJSON().join("");
  }

  let visibleMenu =
    !isEmpty(state.profile.get("displayName")) ||
    state.profile.get("showLanguage") ||
    exitLink ||
    betHistoryLink ||
    continuePlayingLink ||
    gameRoundHistoryLink ||
    supportedLanguagesLink ||
    showCashier ||
    showSwitchDevice ||
    allowMultiGamePlay ||
    canToggleProviderLogoOnGames;

  return {
    allowProfileEdit: state.links.get("allowProfileEdit"),
    version: state.application.get("version"),
    buildno: state.application.get("buildno"),
    isMobile: state.window.get("isMobile"),
    height: state.window.get("height"),
    betHistoryLink: betHistoryLink ? betHistoryLink : null,
    gameRoundHistoryLink: gameRoundHistoryLink ? gameRoundHistoryLink : null,
    continuePlayingLink: continuePlayingLink ? continuePlayingLink : null,
    supportedLanguagesLink: supportedLanguagesLink
      ? supportedLanguagesLink
      : null,
    exitLink: exitLink ? exitLink : null,
    displayName: state.profile.get("displayName"),
    showLanguage: state.profile.get("showLanguage"),
    balance: state.profile.get("balance"),
    symbol: symbols,
    showMenu: state.application.get("showMenu"),
    showGameHistory: state.application.get("showGameHistory"),
    menu: state.cookie.get("menu"),
    visibleMenu: visibleMenu,
    filtersVisible: state.config.get("filtersVisible"),
    recentlyPlayedGames,
    showCashier,
    showSwitchDevice,
    allowMultiGamePlay,
    isMultiGame: state.links.get("isMultiGame"),
    canToggleProviderLogoOnGames: canToggleProviderLogoOnGames !== undefined ? canToggleProviderLogoOnGames : false,
    showProviderLogoOnGames: showProviderLogoOnGames !== undefined ? showProviderLogoOnGames : true
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    clearBetHistory: () => dispatchProps.clearBetHistory(),
    setMenuVisibility: (value) => dispatchProps.setMenuVisibility(value),
    setGameHistoryVisibility: (value) =>
      dispatchProps.setGameHistoryVisibility(value),
    setLocale: (locale) => dispatchProps.setLocale(locale),
    showModal: (value) => dispatchProps.showModal(value),
    hideModal: (value) => dispatchProps.hideModal(value),
    showBetHistory: () => dispatchProps.showBetHistory(),
    setMenu: (value) => dispatchProps.setMenu(value),
    getMenu: () => dispatchProps.getMenu(),
    fetchExit: (route) => dispatchProps.fetchExit(route),
    fetchGames: (route, params) => dispatchProps.fetchGames(route, params),
    wlFetchProfile: () => dispatchProps.wlFetchProfile(),
    navigateTo: (path) => ownProps.history.push(path),
    broadcastCashier: () => dispatchProps.broadcastCashier(),
    broadcastSwitchDevice: (params, gameId) =>
      dispatchProps.broadcastSwitchDevice(params, gameId),
    broadcastGameMode: (gameMode) => dispatchProps.broadcastGameMode(gameMode),
    setMultigameEnabled: (bol) => dispatchProps.setMultigameEnabled(bol),
    setGameProviderImagesEnabled: (bol) => dispatchProps.setGameProviderImagesEnabled(bol),
    fetchLanguage: (route) => dispatchProps.fetchLanguage(route),
    setLanguage: (payload) => dispatchProps.setLanguage(payload),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(withNamespaces("translation")(Menu));
